import {
  CREATE_ORG_REQUESTED,
  CREATE_ORG_SUCCESS,
  CREATE_ORG_FAILURE,
  CREATE_AWS_ORG_REQUESTED,
  CREATE_AWS_ORG_SUCCESS,
  CREATE_AWS_ORG_FAILURE,
  UPDATE_ORG_REQUESTED,
  UPDATE_ORG_SUCCESS,
  UPDATE_ORG_FAILURE,
  GET_ORG_REQUESTED,
  GET_ORG_SUCCESS,
  GET_ORG_FAILURE,
  UPDATE_STRIPE_SOURCE_SUCCESS,
  BILLING_SETUP_COMPLETED,
  GET_UPCOMING_INVOICE_REQUESTED,
  GET_UPCOMING_INVOICE_SUCCESS,
  GET_UPCOMING_INVOICE_FAILURE,
  GET_PAST_INVOICES_REQUESTED,
  GET_PAST_INVOICES_SUCCESS,
  GET_PAST_INVOICES_FAILURE,
} from '../actions';

export const initialState = {
  companyName: null,
  id: null,
  primaryEmail: null,
  phoneNumber: null,
  billingSetupComplete: null,
  billingType: 1,
  isSaving: false,
  isLoading: false,
  error: null,
  pastInvoices: [],
  upcomingInvoices: [],
  trialCreditCents: null,
  awsCustomer: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BILLING_SETUP_COMPLETED:
      return {
        ...state,
        billingSetupComplete: true,
      };

    case GET_ORG_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case CREATE_AWS_ORG_SUCCESS:
    case CREATE_ORG_SUCCESS:
    case UPDATE_ORG_SUCCESS:
    case GET_ORG_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isSaving: false,
      };

    case GET_ORG_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case CREATE_AWS_ORG_REQUESTED:
    case CREATE_ORG_REQUESTED:
    case UPDATE_ORG_REQUESTED:
      return {
        ...state,
        isSaving: true,
      };

    case CREATE_AWS_ORG_FAILURE:
    case CREATE_ORG_FAILURE:
    case UPDATE_ORG_FAILURE:
      return {
        ...state,
        isSaving: false,
        error: action.payload,
      };

    case UPDATE_STRIPE_SOURCE_SUCCESS:
      return {
        ...state,
        stripeCustomerId: action.payload.stripeCustomerId,
      };

    case GET_UPCOMING_INVOICE_REQUESTED:
      return {
        ...state,
      };

    case GET_UPCOMING_INVOICE_SUCCESS:
      if (action.payload.detail && action.payload.detail.includes('no upcoming invoice')) {
        return {
          ...state,
          upcomingInvoices: [],
        };
      }
      return {
        ...state,
        upcomingInvoices: [action.payload],
      };

    case GET_UPCOMING_INVOICE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PAST_INVOICES_REQUESTED:
      return {
        ...state,
      };

    case GET_PAST_INVOICES_SUCCESS:
      return {
        ...state,
        pastInvoices: [...action.payload],
      };

    case GET_PAST_INVOICES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};
